export const MOMENT_FORMAT = {
  Y: 'YYYY',
  YMD: 'YYYYMMDD',
  YYMD: 'YYMMDD',
  MMMD_SPACE: 'MMM DD',
  YMD_DASH: 'YYYY-MM-DD',
  MD_SLASH: 'MM/DD',
  YMD_SLASH: 'YYYY/MM/DD',
  HM_COLON: 'HH:mm',
  HMS_COLON: 'HH:mm:ss',
  YMDHM: 'YYYYMMDDHHmm',
  YMD_DASH_HM_COLON: 'YYYY-MM-DD HH:mm',
  YMD_DASH_HMS_COLON: 'YYYY-MM-DD HH:mm:ss',
  YMD_SLASH_HM_COLON: 'YYYY/MM/DD HH:mm',
  YMD_SLASH_HMS_COLON: 'YYYY/MM/DD HH:mm:ss',
  MD_SLASH_HM_COLON: 'MM/DD HH:mm',
};
